import { IFederalLawErvk } from 'APIPackage/CatalogsModule/interfaces/IFederalLawErvk';

import { IFederalLawSelectOption } from '../interfaces/IFederalLawSelectOption';

export function createFederalLawsSelectOption(law: IFederalLawErvk): IFederalLawSelectOption {
  return {
    ...law,
    label: law.name,
    value: law.name,
  };
}
